import {
  convertTableMapDataToTableDataType,
  scheduleDataType,
  scheduleDataWithShiftNameType,
  scheduledMissedTotalCountType,
  scheduledReportType,
  storeTableDataMapValue,
} from './model'
const isOnScheduleText = 'On schedule'
const isMissedText = 'Missed'
export const checkIsScheduled = (data: scheduleDataType) => {
  const state = data['Check state']
  const isScheduled = state?.toLowerCase() === isOnScheduleText?.toLowerCase()
  return isScheduled
}
export const checkIsMissed = (data: scheduleDataType) => {
  const state = data['Check state']
  const isMissed = state?.toLowerCase() === isMissedText?.toLowerCase()
  return isMissed
}

export const storeTableDataAfterReportUpload = (data: scheduleDataType[], shiftName: string) => {
  const tableDataMap = new Map<string, storeTableDataMapValue>()
  const shiftSet = new Set<string>([shiftName])
  data.forEach((item) => {
    const client = item.Client
    const site = item.Site
    const checkPoint = item['Check Point']
    const isMissed = checkIsMissed(item)
    const isScheduled = checkIsScheduled(item)
    if (!client || !site) return
    const allKey = shiftName
    const clientKey = `${shiftName}-${client}`
    const clientSiteKey = `${shiftName}-${client}-${site}`
    if (!tableDataMap.has(allKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(allKey, value)
    } else if (tableDataMap.has(allKey)) {
      const prevValue = tableDataMap.get(allKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(allKey, value)
    }
    if (!tableDataMap.has(clientKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(clientKey, value)
    } else if (tableDataMap.has(clientKey)) {
      const prevValue = tableDataMap.get(clientKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(clientKey, value)
    }
    if (!tableDataMap.has(clientSiteKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(clientSiteKey, value)
    } else if (tableDataMap.has(clientSiteKey)) {
      const prevValue = tableDataMap.get(clientSiteKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(clientSiteKey, value)
    }
  })
  return {tableDataMap, shiftSet}
}

export const storeTableDataAfterReportsSelect = (data: scheduleDataWithShiftNameType[]) => {
  const tableDataMap = new Map<string, storeTableDataMapValue>()
  const shiftSet = new Set<string>()
  data.forEach((item) => {
    const client = item.Client
    const site = item.Site
    const shiftName = item.shiftname
    const id = item.id;
    shiftSet.add(`${id}-${shiftName}`)
    const checkPoint = item['Check Point']
    const isMissed = checkIsMissed(item)
    const isScheduled = checkIsScheduled(item)
    if (!client || !site) return
    const allKey = `${id}-${shiftName}`
    const clientKey = `${id}-${shiftName}-${client}`
    const clientSiteKey = `${id}-${shiftName}-${client}-${site}`
    if (!tableDataMap.has(allKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(allKey, value)
    } else if (tableDataMap.has(allKey)) {
      const prevValue = tableDataMap.get(allKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(allKey, value)
    }
    if (!tableDataMap.has(clientKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(clientKey, value)
    } else if (tableDataMap.has(clientKey)) {
      const prevValue = tableDataMap.get(clientKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(clientKey, value)
    }
    if (!tableDataMap.has(clientSiteKey)) {
      const value: storeTableDataMapValue = {
        missed: isMissed ? 1 : 0,
        scheduled: isScheduled ? 1 : 0,
        checkPoints: new Set([checkPoint]),
        shiftName,
        total: 1,
      }
      tableDataMap.set(clientSiteKey, value)
    } else if (tableDataMap.has(clientSiteKey)) {
      const prevValue = tableDataMap.get(clientSiteKey) as storeTableDataMapValue
      const checkPointSet = prevValue.checkPoints
      const value: storeTableDataMapValue = {
        missed: prevValue.missed + (isMissed ? 1 : 0),
        scheduled: prevValue.scheduled + (isScheduled ? 1 : 0),
        checkPoints: checkPointSet.add(checkPoint),
        shiftName,
        total: prevValue.total + 1,
      }
      tableDataMap.set(clientSiteKey, value)
    }
  })
  return {tableDataMap, shiftSet}
}

export const getChartData = (data: scheduleDataType[]) => {
  let totalCount = 0
  let missed = 0
  let scheduled = 0
  for (let i = 0; i < data.length; i++) {
    const currentItem = data[i]
    totalCount += 1
    missed += checkIsMissed(currentItem) ? 1 : 0
    scheduled += checkIsScheduled(currentItem) ? 1 : 0
  }
  return {totalCount, missed, scheduled}
}

export const getClientsAndStoreSites = (data: scheduleDataType[]) => {
  const clientSiteMap = new Map<string, Map<string, scheduledMissedTotalCountType>>()
  if (!data || !Array.isArray(data) || (Array.isArray(data) && data.length === 0)) return new Map()
  data?.forEach((item) => {
    const clientKey = item.Client
    const site = item.Site
    const state = item['Check state']
    if (!clientKey) return
    if (clientSiteMap.has(clientKey)) {
      const siteMap = clientSiteMap.get(clientKey) as Map<string, scheduledMissedTotalCountType>
      if (!siteMap.has(site)) {
        const isMissed = checkIsMissed(item)
        const isScheduled = checkIsScheduled(item)
        siteMap.set(site, {total: 1, missed: isMissed ? 1 : 0, scheduled: isScheduled ? 1 : 0})
      } else {
        const {missed, scheduled, total} = siteMap?.get(site) as scheduledMissedTotalCountType
        siteMap.set(site, {
          total: total + 1,
          missed: missed + (checkIsMissed(item) ? 1 : 0),
          scheduled: scheduled + (checkIsScheduled(item) ? 1 : 0),
        })
      }
    } else {
      const isMissed = checkIsMissed(item)
      const isScheduled = checkIsScheduled(item)
      const siteMap = new Map<string, scheduledMissedTotalCountType>()
      siteMap.set(site, {total: 1, missed: isMissed ? 1 : 0, scheduled: isScheduled ? 1 : 0})
      clientSiteMap.set(clientKey, siteMap)
    }
  })
  return clientSiteMap
}

export const convertTableMapDataToTable = ({
  shifts,
  selectedClient,
  selectedSite,
  tableDataMap,
}: convertTableMapDataToTableDataType): scheduledReportType[] => {
  if(shifts.size === 0 && tableDataMap.size === 0) return[];
  let tableData : scheduledReportType[] = [];
  shifts?.forEach((shiftNameWithId) => {
    const mapKey = !selectedClient
      ? shiftNameWithId
      : !selectedSite
      ? `${shiftNameWithId}-${selectedClient}`
      : `${shiftNameWithId}-${selectedClient}-${selectedSite}`
      const storedTableValue = tableDataMap.get(mapKey) as storeTableDataMapValue
    const {checkPoints, missed, scheduled, total, shiftName} = storedTableValue
    tableData.push({
      shift: shiftName,
      checkpoints: checkPoints.size,
      expectedScans: total,
      missedScans: missed,
      successfulScans: scheduled,
      successScanPercentage: (scheduled / total)?.toFixed(2),
    })
  })
  return tableData;
}